export default "__VITE_ASSET__BaaogJPX__"